export default class Discrepancy {

    static readonly MISSING_INT: number = 1;
    static readonly MISSING_OPT: number = 2;
    static readonly MISSING_COM: number = 3;
    static readonly AUX_EQUIP: number = 4;
    static readonly OPTION_INFO: number = 5;
    static readonly INFO_OTHER: number = 6;
    static readonly MISSING_PKG: number = 7;
    static readonly MISSING_CUST: number = 8;
    static readonly LABOR_NA: number = 9;

    id: number;
    desc: string;

    value:number;
    text: string;

    /*
        This was a feature that was added later, the request is to have inputs dynamically show when discrepancy
        has the the text missing in it.  I dont think the the dbs have consistent enum values.  Ideally it should also
        be a getter but the app doesn't initialize this class in any of it's usages.
     */
    public static isMissing(discrepancy?: Discrepancy): boolean {
        if (discrepancy) return discrepancy.desc.toLowerCase().includes('missing');
        return false;
    }

    constructor(){
        this.id = 0;
        this.desc = "";

        this.value = 0;
        this.text = "";
    }
}